import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";
import { ChartLabels, DonutChart } from "../../components/Charts";
import { useUserInfo } from "../../utils/security";
import { isEmpty } from "lodash";
import { generateColors } from "../../utils/colors";

export const TransactionTypesChart = ({ data, loading }) => {
    const { userInfo } = useUserInfo();
    const theme = useTheme();

    if (isEmpty(data) || loading) {
        return (
            <Box>
                <DonutChart data={[]} labels={[]}></DonutChart>
                <Skeleton variant="rectangular" height={85} sx={{ my: 2, width: "100%" }} />
            </Box>
        );
    }

    const chartColors = generateColors(
        [
            theme.palette.primary.light,
            theme.palette.secondary.light,
            theme.palette.tertiaryFixedDim.main,
        ],
        userInfo?.transactionTypes?.length
    );
    const typesMap = userInfo?.transactionTypes?.reduce(
        (acc, type) => ({ ...acc, [type?.id]: 0 }),
        {}
    );
    data?.forEach((type) => {
        typesMap[type?.id] = type?.amount;
    });

    return (
        <>
            <Box>
                <DonutChart
                    data={[userInfo?.transactionTypes?.map((tt) => typesMap[tt.id] || 0)]}
                    labels={[]}
                    colors={chartColors}
                    useChartColors={false}></DonutChart>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-around",
                }}>
                <Box sx={{ p: 1 }}>
                    <ChartLabels
                        labels={userInfo.transactionTypes
                            ?.filter((_, idx) => idx % 2 === 0)
                            .map((tt, idx) => ({
                                name: tt.name,
                                value: typesMap[tt.id] || 1,
                                color: chartColors[idx * 2],
                            }))}
                    />
                </Box>
                <Box sx={{ p: 1 }}>
                    <ChartLabels
                        labels={userInfo.transactionTypes
                            ?.filter((_, idx) => idx % 2 === 1)
                            .map((tt, idx) => ({
                                name: tt.name,
                                value: typesMap[tt.id],
                                color: chartColors[idx * 2 + 1],
                            }))}
                        color={theme.palette.primary.main}
                    />
                </Box>
            </Box>
        </>
    );
};
